import * as React from 'react';

import { NewButton } from '../../../components/synced/ui/NewButton/NewButton';
import { NewDropdown } from '../../../components/synced/ui/NewDropdown/NewDropdown';
import { NewMultiSelect } from '../../../components/synced/ui/NewMultiSelect/NewMultiSelect';
import { ReportFiltersState } from './useReportFilters';
import styles from './ReportFilterBar.module.css';

interface ReportFilterBarProps extends ReportFiltersState {
  isLoading: boolean;
  isDownloading?: boolean;
  onView: () => void;
  onDownload?: () => void;
}

export const ReportFilterBar: React.FC<ReportFilterBarProps> = ({
  statuses, selectedStatuses, setSelectedStatuses, loadingStatuses,
  projects, selectedProject, setSelectedProject, loadingProjects,
  projectDocs, selectedProjectDoc, setSelectedProjectDoc, loadingProjectDocs,
  isLoading, isDownloading = false, onView, onDownload,
}) => (
  <div className={styles.bar}>
    <div className={styles.filters}>
      <div className={styles.field}>
        <span className={styles.label}>Статус</span>
        <NewMultiSelect
          value={selectedStatuses}
          options={statuses}
          optionLabel="Title"
          placeholder="Выберите статус"
          selectedItemsLabel="Выбрано: {0}"
          disabled={loadingStatuses}
          onChange={e => {
            setSelectedStatuses(e.value);
            setSelectedProject(undefined);
            setSelectedProjectDoc(undefined);
          }}
          className={styles.select}
        />
      </div>

      <div className={styles.field}>
        <span className={styles.label}>Проект</span>
        <NewDropdown
          value={selectedProject}
          options={projects}
          optionLabel="Title"
          placeholder="Выберите проект"
          filter
          disabled={loadingProjects || loadingStatuses || selectedStatuses.length < 1}
          onChange={e => {
            setSelectedProject(e.value);
            setSelectedProjectDoc(undefined);
          }}
          className={styles.select}
        />
      </div>

      <div className={styles.field}>
        <span className={styles.label}>Документация</span>
        <NewDropdown
          value={selectedProjectDoc}
          options={projectDocs}
          optionLabel="Title"
          placeholder="Выберите документацию"
          filter
          disabled={loadingProjectDocs || loadingProjects || loadingStatuses || !selectedProject}
          onChange={e => setSelectedProjectDoc(e.value)}
          className={styles.select}
        />
      </div>
    </div>

    <div className={styles.actions}>
      <NewButton
        variant="secondary"
        icon="fa-regular fa-eye"
        disabled={isLoading}
        onClick={onView}
      >
        Просмотр
      </NewButton>
      {onDownload && selectedProjectDoc && (
        <NewButton
          variant="green"
          icon={isDownloading ? `pi pi-spin pi-spinner` : `fa-solid fa-download`}
          disabled={isLoading || isDownloading}
          onClick={onDownload}
        >
          {isDownloading ? `Скачивание…` : `Скачать`}
        </NewButton>
      )}
    </div>
  </div>
);
